import { omit } from 'lodash';

/**
 * Filter out fields that should not be processed from uploaded settings
 *
 * @param {object} settings - Parsed settings from uploaded YAML
 * @returns {object} Filtered settings
 */
export default function filterUploadedSettings(settings) {
  // writeKey is determined by the pipeline location in the UI
  return omit(settings, ['writeKey']);
}
